<div class="uploaded-files-list">
  
  <div class="file-item" *ngFor="let file of files" [ngbTooltip]="file?.name ? file?.name : ''">
    <a [href]="file?.url" target="_blank">
      <img src="./assets/images/file-earmark-medical.svg" alt="file-earmark-medical">
    </a>
  </div>
</div>
